class Series extends Array {
    constructor(name, dimensions, data, sources) {
        super();

        // unfortunately there is an issue with extending native classes in babel https://github.com/babel/babel/issues/3083
        // probably solved by babel-plugin-transform-builtin-extend
        //this.constructor = Series;
        //this.__proto__   = Series.prototype;
        
        if (typeof(dimensions) !== 'number' || !Number.isInteger(dimensions) || dimensions < 1) {
            throw new TypeError('dimensions must be an integer greater than 0');
        }

        this.dimensions = dimensions;
        this.name = name;

        if (typeof(sources) === 'undefined') {
            this.sources = [];
            //this.sources.fill(undefined, 0, this.length - 1);
        }
        else if (!(sources instanceof Array)) {
            throw new TypeError('sources must be an array');
        }
        else {
            this.sources = sources;
        }

        if (typeof(data) !== 'undefined') {
            if (!(data instanceof Array)) {
                throw new TypeError('data must be an array');
            }
            else {
                for (let i = 0; i < data.length; i++) {
                    this.push(data[i]);
                }
            }
        }

        if (this.sources.length < this.length) {
            this.sources.concat(new Array(this.length - this.sources.length).fill(undefined));
        }
    }

    push(...items) {
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (this.dimensions > 1 && item.length !== this.dimensions) {
                throw new Error(`Number of values must be equal to expected dimension of data: ${this.dimensions}, error at index ${i}`);
            }
        }

        if (this.sources.length < this.length + items.length) {
            this.sources = this.sources.concat(new Array(items.length).fill(undefined));
        }

        return super.push.apply(this, items);
    }

    concat(...otherSeries) {
        let sources = this.getSources();
        let data = this.toArray();
        const name = [this.name];

        for (let i = 0; i < otherSeries.length; i++) {
            const item = otherSeries[i];

            if (!(item instanceof Series)) {
                throw new TypeError(`Only instances inheriting from Series class can be merged, error at index ${i}`);
            }
    
            if (item.dimensions !== this.dimensions) {
                throw new TypeError(`Only series with the same dimensions can be merged, this series dimension, otherSeries dimensions ${this.dimensions}: ${item.dimensions}, error at index ${i}`);
            }

            sources = sources.concat(item.sources);
            data = data.concat(item);
            name.push(item.name);
        }

        return new Series(name.join(', '), this.dimensions, data, sources);
    }

    add(source, ...values) {
        const index = this.dimensions === 1 ? this.push(...values) : this.push(values);

        this.sources[index-1] = source;
        return index;
    }

    getValue(dataIndex, dimensionNr) {
        if (typeof(dataIndex) !== 'number') {
            throw new TypeError('dataIndex must be an number');
        }

        if (typeof(dimensionNr) === 'undefined'){
            return this[dataIndex];
        }

        if (typeof(dimensionNr) !== 'number' || !Number.isInteger(dimensionNr) || dimensionNr < 1) {
            throw new TypeError('dimensionNr must be an integer greater than 0');
        }

        if (dimensionNr > this.dimensions) {
            throw new Error(`dimensionNr is greater than number of dimensions for this series: ${this.dimensions}`)
        }

        return this.dimension === 1 ? this[dataIndex]: this[dataIndex][dimensionNr-1];
    }

    getSource(dataIndex) {
        if (typeof(dataIndex) !== 'number') {
            throw new TypeError('dataIndex must be an number');
        }

        return this.sources[dataIndex];
    }

    getSources() {
        return [].concat(this.sources);
    }

    getDimension(dimensionNr) {
        if (typeof(dimensionNr) !== 'number' || !Number.isInteger(dimensionNr) || dimensionNr < 1) {
            throw new TypeError('dimensionNr must be an integer greater than 0');
        }

        if (dimensionNr > this.dimensions) {
            throw new Error(`dimensionNr is greater than number of dimensions for this series: ${this.dimensions}`)
        }

        return this.toArray().map(v => this.dimensions === 1 ? v: v instanceof Array ? v[dimensionNr-1]: undefined);
    }

    applyCallback(dimensionNr, callback, targetThis) {
        if (typeof(callback) !== 'function') {
            throw new TypeError('callback must be an function');
        }

        const dimension = this.getDimension(dimensionNr);
        return callback.apply(targetThis, dimension);
    }

    toArray() {
        return [].concat(this);
    }
}

export default Series;